// extracted by mini-css-extract-plugin
export default {"root":"UserBadge_root__39WSa","icon":"UserBadge_icon__YRaKg","label":"UserBadge_label__aMdzw"};